module.exports = __webpack_public_path__ + "static/media/lb-nasc.9fa6c117.svg";